import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { get } from '../../controllers/apiController';
import { toast } from 'react-toastify';
import PieChart from '../../components/PieChart';
import BarChart from '../../components/BarChart';

const Dashboard = () => {
    const [isLoading, setIsLoading] = useState(true);

    const [stats, setStats] = useState({});
    const [leads, setLeads] = useState([]);

    const [labelsChartData, setLabelsChartData] = useState({});
    const [campaignsChartData, setCampaignsChartData] = useState({});
    const [keywordsChartData, setKeywordsChartData] = useState({});

    useEffect(() => {
        document.title = "Anasayfa | LEVELUP CRM";

        const fetchStatistics = async () => {
            const res = await get("reports/statistics");

            setStats(res);
        };
    
        const fetchLeads = async () => {
            const res = await get("forms/");

            setLeads(res.data);

            await processData(res.data);
        };

        const fetchAll = async () => {
            try {
                await Promise.all([fetchStatistics(), fetchLeads()]);
            } catch (err) {
                toast.error("Veriler alınırken bir hata oluştu!");
            }

            setIsLoading(false);
        }

        fetchAll();
    }, []);

    const processData = async (leads) => {
        const tagCounts = {};
        const tagColors = {};

        const campaignCounts = {};

        const keywordCounts = {};
    
        leads.forEach((form) => {
            form.Etiketler?.forEach((etiket) => {
                if (tagCounts[etiket.Etiket_Adi]) {
                    tagCounts[etiket.Etiket_Adi]++;
                } else {
                    tagCounts[etiket.Etiket_Adi] = 1;
                    tagColors[etiket.Etiket_Adi] = `#${etiket.Etiket_Renk}`;
                }
            });

            const campaign = form.LeadInfo.UTM_Campaign;
            if (campaign) {
                if (campaignCounts[campaign]) {
                    campaignCounts[campaign]++;
                } else {
                    campaignCounts[campaign] = 1;
                }
            }

            const utmKelime = form.LeadInfo.UTM_Kelime;
            if (utmKelime) {
                if (keywordCounts[utmKelime]) {
                    keywordCounts[utmKelime]++;
                } else {
                    keywordCounts[utmKelime] = 1;
                }
            }
        });
    
        setLabelsChartData({
            labels: Object.keys(tagCounts),
            series: Object.values(tagCounts),
            colors: Object.keys(tagCounts).map(label => tagColors[label])
        });

        setCampaignsChartData({
            labels: Object.keys(campaignCounts),
            series: [
                {
                    name: "Form Sayısı",
                    data: Object.values(campaignCounts),
                }
            ]
        });

        setKeywordsChartData({
            labels: Object.keys(keywordCounts),
            series: [
                {
                    name: "Form Sayısı",
                    data: Object.values(keywordCounts),
                }
            ]
        });
    };

    return (
        <Layout>
            <main className="nxl-container">
                
                <div className="nxl-content">
                    
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        { isLoading ? (
                            <div className="w-100 d-flex align-items-center justify-content-center" style={{ height: '70svh' }}>
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Yükleniyor...</span>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-xxl-3 col-md-6">
                                        <div className="card stretch stretch-full border border-dashed border-gray-5">
                                            <div className="card-body rounded-3 text-center">
                                                <i className="bi bi-facebook fs-3 text-primary"></i>
                                                <div className="fs-4 fw-bolder text-dark mt-3 mb-1">{stats.metaForms}</div>
                                                <p className="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">Bugün Metadan Gelen Kayıt Sayısı</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-3 col-md-6">
                                        <div className="card stretch stretch-full border border-dashed border-gray-5">
                                            <div className="card-body rounded-3 text-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 48 48">
                                                    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
                                                </svg>
                                                <div className="fs-4 fw-bolder text-dark mt-3 mb-1">{stats.adsForms + stats.websiteForms}</div>
                                                <p className="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">Bugün Ads'den Gelen Kayıt Sayısı</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-3 col-md-12">
                                        <div className="card stretch stretch-full border border-dashed border-gray-5">
                                            <div className="card-body rounded-3 text-center">
                                                <i className="bi bi-people fs-3 text-warning"></i>
                                                <div className="fs-4 fw-bolder text-dark mt-3 mb-1">{stats.landingPageFormsToday || 0}</div>
                                                <p className="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">Bugün Landing Page Ziyaretçi Sayısı</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-3 col-md-12">
                                        <div className="card stretch stretch-full border border-dashed border-gray-5">
                                            <div className="card-body rounded-3 text-center">
                                                <i className="bi bi-globe fs-3 text-secondary"></i>
                                                <div className="fs-4 fw-bolder text-dark mt-3 mb-1">{stats.visit || 0}</div>
                                                <p className="fs-12 fw-medium text-muted text-spacing-1 mb-0 text-truncate-1-line">Bugün Web Site Ziyaretçi Sayısı</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xxl-4 col-md-6">
                                        <div className="card stretch stretch-full border border-dashed border-gray-5">
                                            <div className="card-body rounded-3 text-center">
                                                <p className="fs-12 fw-semibold text-muted text-spacing-1 mb-2 text-truncate-1-line">Etiketlere Göre Gelen Formlar</p>
                                                <PieChart
                                                    labels={labelsChartData.labels || []} 
                                                    series={labelsChartData.series || []} 
                                                    colors={labelsChartData.colors || []} 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-4 col-md-6">
                                        <div className="card stretch stretch-full border border-dashed border-gray-5">
                                            <div className="card-body rounded-3 text-center">
                                            <p className="fs-12 fw-semibold text-muted text-spacing-1 mb-2 text-truncate-1-line">Kampanyaya Göre Gelen Formlar</p>
                                                <BarChart 
                                                    labels={campaignsChartData.labels || []}
                                                    series={campaignsChartData.series || []}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-4 col-md-6">
                                        <div className="card stretch stretch-full border border-dashed border-gray-5">
                                            <div className="card-body rounded-3 text-center">
                                                <p className="fs-12 fw-semibold text-muted text-spacing-1 mb-2 text-truncate-1-line">Anahtar Kelimelere Göre Gelen Formlar</p>
                                                <BarChart 
                                                    labels={keywordsChartData.labels || []}
                                                    series={keywordsChartData.series || []}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) }
                    </div>
                </div>

            </main>
        </Layout>
    );
};

export default Dashboard;
